import React from 'react'
import styled from '../../styled'
import { Container } from './Item'
import { Icon_done } from '@yanolja-rnd/ya-com-system-icon'
/**
 * ItemText component
 * author: soojin.oh
 */

// type definitions
type ItemTextImpl = React.FunctionComponent<{
  title: string
  selected: boolean
  id: string
  onClick: (id: string) => void
  testId?: string
}>

// styled components
const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
`
const Text = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  line-height: 1.1em;
`
const Check = styled(Icon_done)`
  path {
    fill: ${({ theme }) => theme.color.blue600};
  }

  @media (min-width: 640px) {
    margin-right: 1.2rem;
  }
`

// ItemText component
const ItemText: ItemTextImpl = function ({ title, selected, id, onClick, testId }) {
  return (
    <Container
      className={selected ? 'selected' : ''}
      onClick={() => onClick(id)}
      data-testid={testId}
    >
      <Title>
        <Text>{title}</Text>
        {selected ? <Check /> : null}
      </Title>
    </Container>
  )
}

export default ItemText
